module.exports = require('./helpers/bundle-url').getBundleURL('2N0CQ') + "logo-dark.eefe0b7f.svg";